define([
    'text!product-detail/component/knowledge-group-new.html',
    'product-detail/component/knowledge-group-item',
    'product-detail/mixin/product',

    'css!product-detail/component/knowledge-group-new.css'
], function(
    tpl,
    KnowledgeGroupItem,
    ProductMixin
){
    return {
        template: tpl,
        components: {
            KnowledgeGroupItem: KnowledgeGroupItem
        },
        mixins: [ProductMixin],
        props: {
            list: {
                type: Array
            }
        },
        data: function(){
            return {
                selectedIndex: -1
            };
        },
        computed: {
            selectedItem: function(){
                return this.list[this.selectedIndex] || null;
            },
            selectedDesc: function(){
                if (!this.selectedItem) return '';
                return this.spuBase[this.selectedItem.field] || '';
            },
            isDelivery: function(){
                return this.selectedItem && this.selectedItem.field === 'artDelivery';
            },
            isPC: function () {
                if($(window).width()<=750){
                    $('.fixed-menu').css({display: 'none'});
                    return false;
                }else {
                    return true;
                }
            }
        },
        methods: {
            selectItem: function(index){
                if (index === this.selectedIndex){
                    this.selectedIndex = -1;
                } else {
                    this.selectedIndex = index;
                }
            }
        },
        mounted: function(){
            var obj = this;
            $(window).resize( function  () {           //当浏览器大小变化时
                if(($(window).width()<=750&&obj.isPC)||($(window).width()>750&&!obj.isPC)){
                    window.location.reload();
                }
            });
        }
    };
});


//////////////////
// WEBPACK FOOTER
// ./product-detail/component/knowledge-group-new.js
// module id = 117
// module chunks = 0